import { render, staticRenderFns } from "./CarDocuments.vue?vue&type=template&id=c66bc86e&scoped=true&"
import script from "./CarDocuments.vue?vue&type=script&lang=js&"
export * from "./CarDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66bc86e",
  null
  
)

export default component.exports